export default "__VITE_ASSET__27PL$fjL__"